import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '../../../../../../../../../shared/cw-utils/snackbar.service';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { PersonService } from '../../../../../../../../../shared/cw-services/person/person.service';
import { Council, Firm, Person, PersonCertificate, PersonElector, PersonIdentity, PersonWorkCard, Professional, Speciality, State } from '../../../../../../../../../shared/cw-backend/models/backend-definitions.module';
import { PageOptions } from '../../../../../../../../../shared/cw-utils/cw-utils.service';
import { SpecialityListProvider } from '../../../../../../../../../shared/cw-backend/providers/accreditation/speciality/speciality-list.provider';
import { CouncilListProvider } from '../../../../../../../../../shared/cw-backend/providers/general/council/council-list.provider';
import { StateListService } from '../../../../../../../../../shared/cw-backend/providers/address/state/state-list-service';
import { Foreign } from '../../../../../../../../../shared/cw-backend/models/tables/general/foreing';
import { FirmListProvider } from '../../../../../../../../../shared/cw-backend/providers/general/firm/firm-list.provider';
import { ProfessionalEditProvider } from '../../../../../../../../../shared/cw-backend/providers/organizational/professional/professional-edit.provider';
import { QuickRegistrationFirmComponent } from '../quick-registration-firm/quick-registration-firm.component';
import {debounceTime, distinctUntilChanged, Subject, takeUntil} from 'rxjs';

@Component({
    selector: 'app-quick-registration-solic',
    templateUrl: './quick-registration-solic.component.html',
    styleUrls: ['./quick-registration-solic.component.scss']
})
export class QuickRegistrationSolicComponent implements OnInit {

    // Tipados com classes
    professionalForm: FormGroup;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    professional = new Professional();
    speciality: Speciality;
    filteredSpecialityList: Speciality[];
    councilList: Council[];
    stateList: State[];
    firmList: Firm[];
    firm: Firm;

    // tipados
    cbo: any;

    // pageoptions
    specialityPageOptions: PageOptions;
    firmPageOptions: PageOptions;

    private _unsubscribeAll: Subject<any>;

    constructor(
        public _matDialogRef: MatDialogRef<QuickRegistrationSolicComponent>,
        private councilListProvider: CouncilListProvider,
        private stateListProvider: StateListService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private specialityListProvider: SpecialityListProvider,
        private professionalEditProvider: ProfessionalEditProvider,
        private firmListProvider: FirmListProvider,
        private snackBarService: SnackBarService,
        private _matDialog: MatDialog,
    ) {
        this._unsubscribeAll = new Subject();
        this.professional = new Professional();
        this.professional.person = new Person();
        this.professional.person.personCertificate = new PersonCertificate();
        this.professional.person.personElector = new PersonElector();
        this.professional.person.personIdentity = new PersonIdentity();
        this.professional.person.personWorkCard = new PersonWorkCard();
        this.professional.person.foreign = new Foreign();
        this.specialityPageOptions = new PageOptions();
        this.firmPageOptions = new PageOptions();
    }

    ngOnInit() {
        this.professionalForm = this.createForm();
        this.getCouncilList();
        this.getStateList();
        this.getListFirm();
        this.getSpecialitySimpleList();
        this.filterSpeciality();
        this.filterFirm();
    }

    dimiss() {
        this._matDialogRef.close();
    }

    createForm(): FormGroup {

        return this._formBuilder.group({

            id: [this.professional.id],
            council: new FormControl(this.professional.council,
                [Validators.required]),
            state: new FormControl(this.professional.state,
                [Validators.required]),
            firm: new FormControl(this.professional.firm),
            councilNumber: new FormControl(this.professional.councilNumber,
                [Validators.required, Validators.maxLength(10)]),
            councilType: new FormControl(this.professional.councilType,
                [Validators.maxLength(1)]),
            active: [this.professional?.id ? this.professional.active : true],
            speciality: [this.professional.speciality, Validators.required],
            staff: new FormControl(this.professional?.id ? this.professional.staff : false),
            specialityList: new FormControl(this.professional.specialityList),
            person: this._formBuilder.group(PersonService.createForm(this.professional.person)),

        });

    };

    filterSpeciality() {
        this.professionalForm.controls['speciality']
            .valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe(res => {
            if (res.name) {
                this.specialityPageOptions.argument = res.name;
            } else if (res) {
                this.specialityPageOptions.argument = res;
            }
            this.getSpecialitySimpleList();
        });
    }

    filterFirm() {
        this.professionalForm.controls['firm'].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe(res => {
            let filter = "";
            if (typeof res ==="string"){
                filter = res;
            }
            this.firmPageOptions.argument = filter;
            this.getListFirm();
        });
    }

    getSpecialitySimpleList() {
        this.specialityListProvider.getPage(this.specialityPageOptions, 'procedure/').then(res => {
            this.filteredSpecialityList = res.body.content;
        });
    }

    displayFn(speciality?: any): string | undefined {
        if (!speciality) {
            return null;
        }
        return speciality.name;
    }

    displayFirmFn(firm?: any): string | undefined {
        if (!firm) {
            return null;
        }
        return firm.name;
    }

    getCouncilList() {
        this.councilListProvider.getAll('professional/').then(res => {
            this.councilList = res.body;
        });
    }

    // Get all states
    getStateList():void {
        this.stateListProvider.getAll().then(res => {
            this.stateList = res.body;
        });
    }

    setSpeciality(speciality) {
        this.speciality = speciality;
        if (speciality) {
            this.cbo = speciality.occupation.code + ' / ' + speciality.occupation.name;
        } else {
            this.cbo = null;
        }
    }

    // Compare object in select
    compareSelect(o1: any, o2: any): boolean {
        if (o1 == null || o2 == null) {
            return null;
        }
        return o1.id === o2.id;
    }

    getListFirm() {
        this.firmListProvider.getPageSimple(this.firmPageOptions)
            .then(result => {
                this.firmList = result.body.content;

            }).catch((error) => {

        })
    }

    confirm() {
        let data = this.professionalForm.getRawValue();

        if (data.firm?.id) {
            let firm = {
                id: this.professionalForm.controls['firm'].value.id,
                name: this.professionalForm.controls['firm'].value.name
            }
            data.firm = firm;
        }

        delete data.person.address;
        delete data.person.foreign;
        delete data.person.personCertificate;
        delete data.person.personElector;
        delete data.person.personIdentity;
        delete data.person.personWorkCard;


        this.professionalEditProvider.insertSolicQuick(data).then((res) => {
            this.professional = res.body.data;
            this._matDialogRef.close(this.professional);
        });
    }

    registrationFirm() {
        const dialog = this._matDialog.open(QuickRegistrationFirmComponent, {
            panelClass: 'clearPadding',
            disableClose: false,
            width: '50%',
        });

        dialog.afterClosed().subscribe(result => {
            if (result) {
                if (result.id) {
                    this.professionalForm.controls['firm'].setValue(result);
                }
            }
        });
    }

}
